import React, { useEffect, useState } from 'react';
import { portalApi, formatApiError } from '../../services/api';
import { Warning } from '@phosphor-icons/react';
import { toast } from 'sonner';

const fmtEUR = (v) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(v || 0));

export default function PortalDamages() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await portalApi.damages();
        setItems(r.data || []);
      } catch (err) { toast.error(formatApiError(err)); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="p-6 space-y-6" data-testid="portal-damages-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-[#111418]">Schäden</h1>
        <p className="text-[#525866] mt-1">Übersicht Ihrer erfassten Schäden</p>
      </div>

      {loading ? (
        <div className="card-swiss h-24 skeleton" />
      ) : items.length === 0 ? (
        <div className="card-swiss p-12 text-center">
          <Warning weight="thin" size={64} className="mx-auto text-[#8A94A6] mb-4" />
          <p className="text-[#525866]">Keine Schäden erfasst.</p>
        </div>
      ) : (
        <div className="card-swiss overflow-hidden">
          <table className="table-swiss">
            <thead><tr><th>Schaden-Nr.</th><th>Datum</th><th>Beschreibung</th><th className="text-right">Kosten</th><th>Status</th></tr></thead>
            <tbody>
              {items.map((d) => (
                <tr key={d.id} data-testid={`portal-damage-row-${d.id}`}>
                  <td className="font-semibold">{d.damage_number}</td>
                  <td className="text-sm text-[#525866]">{d.date || (d.created_at || '').slice(0, 10)}</td>
                  <td className="text-sm">{d.description}</td>
                  <td className="text-right font-semibold">{fmtEUR(d.actual_cost || d.estimated_cost)}</td>
                  <td><span className="text-xs px-2 py-1 rounded bg-[#F5F7FA] text-[#525866] font-semibold">{d.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
